import ServiceListView from "@/views/admin/services/ServiceListView";
import ServiceCreateView from "@/views/admin/services/ServiceCreateView";
import ServiceDetailView from "@/views/admin/services/ServiceDetailView";
import ServiceEditView from "@/views/admin/services/ServiceEditView";

export default [
  {
    name: "pages.admin.services",
    path: "services",
    component: ServiceListView
  },
  {
    name: "pages.admin.services.create",
    path: "services/create",
    component: ServiceCreateView
  },
  {
    name: "pages.admin.services.show",
    path: "services/:id",
    component: ServiceDetailView
  },
  {
    name: "pages.admin.services.edit",
    path: "services/:id/edit",
    component: ServiceEditView
  }
];
